export default function TermsAndConditions() {
  return (
    <main className="page-content">
      <div className="container" style={{ maxWidth: 820 }}>
        <h1 className="page-title">Terms & Conditions</h1>
        <p className="page-subtitle">Effective: 10 May 2026 · Last updated: 10 May 2026</p>

        <div className="legal-section">
          <p>Welcome to GuessUp. By downloading, signing in, or using the GuessUp mobile app, you agree to these Terms and Conditions. Read them carefully. If you don't agree, please don't use the app.</p>

          <h2>1. Eligibility</h2>
          <p>You must be at least 13 years old (or 16 in some EU jurisdictions) to use GuessUp. By creating an account you confirm that you meet this age requirement and that the information you provide is accurate.</p>

          <h2>2. About GuessUp</h2>
          <p>GuessUp is a real-time 1v1 multiplayer number-guessing game. Players add friends, challenge them to duels, optionally agree on a wager, and race to guess each other's secret numbers. Voice chat is built into every match.</p>

          <h2>3. Your account</h2>
          <ul>
            <li>You are responsible for keeping your sign-in credentials secure.</li>
            <li>One account per person. You may not create multiple accounts to abuse friend lists, streaks, or stats.</li>
            <li>Choose a username that does not impersonate other people, brands, or contain offensive language.</li>
            <li>You may delete your account at any time from inside the app or by emailing us.</li>
          </ul>

          <h2>4. Wagers and "deals"</h2>
          <p>GuessUp's wager system lets you and a friend agree on a real-world dare (such as "loser does the dishes") before a match. Important things you should know:</p>
          <ul>
            <li>Wagers are <strong>NOT</strong> real currency or gambling.</li>
            <li>GuessUp does not handle, hold, or transfer any money or item of value.</li>
            <li>The agreement is strictly between you and your friend. We do not enforce, mediate, or guarantee outcomes.</li>
            <li>Do not wager anything illegal, harmful, or that you cannot freely give. By placing a wager you confirm it is consensual and lawful.</li>
            <li>We are not liable for any disputes arising from real-world wagers.</li>
          </ul>

          <h2>5. Voice chat — your responsibility</h2>
          <p>Voice chat is intended for friendly trash talk and post-match debriefing. By using voice chat you agree:</p>
          <ul>
            <li>Not to harass, threaten, or abuse other players</li>
            <li>Not to use voice chat to share illegal, hateful, or sexually explicit content</li>
            <li>Not to record or transmit other players' voices without their consent</li>
            <li>To mute yourself or end calls if you feel uncomfortable</li>
          </ul>
          <p>We do not record voice chat, but we reserve the right to suspend accounts based on credible reports of abuse.</p>

          <h2>6. Fair play</h2>
          <ul>
            <li>No bots, automation, or modified clients</li>
            <li>No exploiting bugs to inflate stats or streaks</li>
            <li>No deliberately disconnecting to dodge a loss</li>
            <li>No harassment of other players via username, in-game messages, or voice chat</li>
          </ul>
          <p>Violations may result in warnings, account suspension, or permanent ban at our discretion.</p>

          <h2>7. Acceptable content</h2>
          <p>You will not upload, transmit, or display any content (username, avatar, in-app messages) that is unlawful, defamatory, obscene, hateful, infringing, or otherwise objectionable.</p>

          <h2>8. Intellectual property</h2>
          <p>All app content — code, graphics, branding, gameplay design, and the GuessUp name and logo — is owned by us and protected by intellectual property laws. You may not copy, modify, distribute, sell, or create derivative works without prior written permission.</p>

          <h2>9. Push notifications</h2>
          <p>By default, GuessUp sends push notifications about friend requests, game invitations, and wager outcomes. You can disable any or all of these in your phone's settings or in the app's Settings → Notifications screen.</p>

          <h2>10. App availability and updates</h2>
          <p>GuessUp is provided "as is" and "as available." We may update, suspend, or discontinue features, services, or the entire app at any time. We will give reasonable notice of major changes when possible.</p>

          <h2>11. Disclaimers</h2>
          <ul>
            <li>The app is provided without warranties of any kind, either express or implied.</li>
            <li>We do not guarantee uninterrupted, error-free, or secure operation.</li>
            <li>Match outcomes are determined by client + server logic and are final once a round completes.</li>
            <li>We are not responsible for the conduct of other users or for any real-world consequences of wagers between friends.</li>
          </ul>

          <h2>12. Limitation of liability</h2>
          <p>To the maximum extent allowed by law, GuessUp and its developers are not liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the app — including loss of friendships, wager disputes, lost time, lost data, or hurt feelings from being beaten too many times in a row.</p>

          <h2>13. Termination</h2>
          <p>We may suspend or terminate your access to GuessUp if you breach these Terms or engage in conduct we reasonably believe is harmful to other users or the service. You may terminate your account at any time from in-app settings.</p>

          <h2>14. Changes to these terms</h2>
          <p>We may revise these Terms from time to time. Material changes will be announced in-app and at the top of this page. Continuing to use GuessUp after the changes take effect means you accept them.</p>

          <h2>15. Governing law</h2>
          <p>These Terms are governed by the laws of Pakistan. Any disputes will be resolved exclusively in the competent courts of Pakistan, except where local consumer law gives you the right to sue in your home country.</p>

          <h2>16. Contact</h2>
          <p>For questions about these Terms, email us at <a href="mailto:webmalik3@gmail.com" style={{ color: 'var(--sky-bot)', fontWeight: 600 }}>webmalik3@gmail.com</a>.</p>
        </div>
      </div>
    </main>
  );
}
